export default "__VITE_ASSET__zcDa5Qts__"